import {invokeApi} from '@/resource/js/GLOBAL2'

let CARTSTATE = {generalCart:'gener',quickCart:'quick'};
let CARTSTATENAME = {generalCart:'常规运送',quickCart:'极速达'};
let CARTSTATETRANS = ['coldChainCart','nomalTempCart'];
let CARTSTATETRANSPRO = ['products','promotions','frees'];
const state = {
    generalCartPrice:0,
    indexSectionList:[],
    indexSectionListSet:[],
    productDetail:{},
    productDetailSet:{},
    selectPro:[],
    cartS:[],
    deliverDates:[],
    addressInfo:'',
    deliverTime:'',
    cart:{
        generalCart:{
            coldChainCart:{
                products:[],
                promotions:[],
                frees:[]
            },
            nomalTempCart:{
                products:[],
                promotions:[],
                frees:[]
            },
            valid:[],
            soldOut:[],
            factPrice:0.00,
            price:0.00,
            totalQuantity:0,
            freight:0.00,
            selPid:'',
            btnAble:false,
            coldMsg:'',
            nomMsg:'',
            quickMsg:'',
            cartVal:'',
            cartName:'',
            sort:0,
        },
        quickCart:{
            coldChainCart:{
                products:[],
                promotions:[],
                frees:[]
            },
            nomalTempCart:{
                products:[],
                promotions:[],
                frees:[]
            },
            valid:[],
            soldOut:[],
            factPrice:0.00,
            price:0.00,
            totalQuantity:0,
            freight:0.00,
            selPid:'',
            btnAble:false,
            coldMsg:'',
            nomMsg:'',
            quickMsg:'',
            cartVal:'',
            cartName:'',
            sort:1,
        },
    },
    cartTotalCount:0
}
const getters = {
    indexSectionListSet(){
        return state.indexSectionListSet
    },
    selectPro(){
        return state.selectPro
    },
    cart(){
        return state.cart
    },
    cartS(){
        return state.cartS
    },
    productDetail(){
        return state.productDetailSet
    },
};

const actions = {
    initIndexDataInfo({commit,state},param){
        return new Promise((resolve,reject)=>{
            invokeApi('index/getIndexNavProductList', param, 'get', Math.random(), function (res) {
                resolve(res)
                commit('SET_INDEX_DATA',res.navs)

            })
        })
    },
    initGatherDataInfo({commit,state},param){
        return new Promise((resolve,reject)=>{
            invokeApi('index/getProductListByTicketBatchId', param, 'get', Math.random(), function (res) {
                resolve(res)
                commit('SET_INDEX_DATA',res.list)

            })
        })
    },
    initCardGatherDataInfo({commit,state},param){
        return new Promise((resolve,reject)=>{
            invokeApi('prepay/getBuyCardList', param, 'get', Math.random(), function (res) {
                resolve(res)
                state.indexSectionList = res

            })
        })
    },
    initCartDataInfo({commit,state},param){
        return new Promise((resolve,reject)=>{
            invokeApi('shoppingcart/cartList', param, 'post', Math.random(), function (res) {
                resolve(res)
                commit('SET_CART_DATA',{data:res,from:'init'})
                commit('SET_INDEX_PRO_DATA')
                commit('SET_DETAIL_PRO_DATA')
            })
        })
    },
    initDetailDataInfo({commit,state},param){
        return new Promise((resolve,reject)=>{
            invokeApi('index/getItemDetail', param, 'get', Math.random(), function (res) {
                resolve(res)
                commit('SET_DETAIL_DATA',res)

            })
        })
    },
    addProCartData({commit,state},param){
        return new Promise((resolve,reject)=>{
            invokeApi('shoppingcart/addCart', param.param, 'post', Math.random(), function (res) {
                resolve(res)
                commit('SET_CART_DATA',{data:res,from:'set',pro:param.pro,idName:param.idName})
                commit('SET_INDEX_PRO_DATA')
                commit('SET_DETAIL_PRO_DATA')

            })
        })
    }

};
const mutations = {
    GET_GENERCART_PRICE(state,param){
        state.generalCartPrice = param
    },
    SET_INDEX_DATA(state,param){
        for(let i=0;i<param.length;i++){
            param[i].items.map((item)=>{
                item.quantity=0
                return item
            })

        }
        state.indexSectionList = param
    },
    SET_DETAIL_DATA(state,param){
        param.quantity=0
        state.productDetail = param
    },
    SET_DETAIL_PRO_DATA(state,param){
        let data = state.productDetail
        let selArr = state.selectPro
        if(data!={}){
            data.quantity = 0
            selArr.forEach((item)=>{
                if(item.proId == data.productId||(data.promotionId!=null&&item.promotionId==data.promotionId)){
                    data.quantity = item.quantity
                }
            })
        }
        state.productDetailSet = data
    },
    SET_INDEX_PRO_DATA(state,param){
        let data = state.indexSectionList
        let selArr = state.selectPro
        console.log(state.selectPro)
        for(let i=0;i<data.length;i++){
            data[i].items.map((item)=>{
                item.quantity=0
                selArr.forEach((item1)=>{
                    if(item1.proId == item.productId||(item.promotionId!=null&&item1.promotionId==item.promotionId)){

                        item.quantity = item1.quantity
                    }
                })
                return item
            })

        }
        state.indexSectionListSet = data
    },
    SET_CART_DATA(state,param){
        state.cartS = []
        let data = param.data
        state.selectPro = []
        for(var key in CARTSTATE){
            if(data.hasOwnProperty(key)){
                state.cart[key].valid = [];
                state.cart[key].soldOut = [];
                for(var key1 in CARTSTATETRANS){
                    if(data[key].hasOwnProperty(CARTSTATETRANS[key1])){
                        for(var key2 in CARTSTATETRANSPRO){
                            let dataPro = data[key][CARTSTATETRANS[key1]][CARTSTATETRANSPRO[key2]]?data[key][CARTSTATETRANS[key1]][CARTSTATETRANSPRO[key2]]:[];
                            dataPro.map(function (item,index) {
                                item.quantity = item.count
                                if(item.valid == false){
                                    state.cart[key].valid.push(item);
                                    dataPro.splice(index,1)
                                }
                                if(item.quantity>0){
                                    state.selectPro.push(item)
                                }
                                return item
                            })
                            if(param.from=='init'){
                                state.cart[key][CARTSTATETRANS[key1]][CARTSTATETRANSPRO[key2]] = dataPro||[]

                            }else{
                                let dataProOld = state.cart[key][CARTSTATETRANS[key1]][CARTSTATETRANSPRO[key2]]?state.cart[key][CARTSTATETRANS[key1]][CARTSTATETRANSPRO[key2]]:[];

                                dataProOld.map(function (item,index) {
                                    if(item.quantity<=0){
                                        console.log('重置'+item.quantity)
                                        state.cart[key][CARTSTATETRANS[key1]][CARTSTATETRANSPRO[key2]] = dataPro||[]
                                        return
                                    }
                                })

                                if(CARTSTATETRANSPRO[key2]=='frees'){
                                    state.cart[key][CARTSTATETRANS[key1]][CARTSTATETRANSPRO[key2]] = data[key][CARTSTATETRANS[key1]][CARTSTATETRANSPRO[key2]]||[]
                                }
                            }
                        }

                    }else{
                        for(var key2 in CARTSTATETRANSPRO){
                            state.cart[key][CARTSTATETRANS[key1]][CARTSTATETRANSPRO[key2]] = []
                        }
                    }
                }
                state.cart[key].factPrice = setPrice(data[key].factPrice);
                state.cart[key].price = setPrice(data[key].price);
                state.cart[key].totalQuantity = data[key].totalQuantity;
                state.cart[key].freight = setPrice(data[key].freight);
                state.cart[key].btnAble =data[key].balanceStatus;
                state.cart[key].coldMsg = data[key].coldchainNotice;
                state.cart[key].nomMsg = data[key].nomalNotice;
                state.cart[key].quickMsg = data[key].quickNotice;
                state.cart[key].sort = data[key].sort;
                state.cart[key].cartVal = CARTSTATE[key];
                state.cart[key].cartName = CARTSTATENAME[key];
                state.cartS[data[key].sort]= state.cart[key];
            }
        }
        state.activeTab = state.cartS.length>0?state.cartS[0].cartVal:'gener'

        state.deliverDates = data.deliver?data.deliver.deliverDates:[]
        state.addressInfo = data.address?data.address.address:''
        state.deliverTime = data.deliver?data.deliver.deliverDateShow:''
        state.cartTotalCount = data.totalQuantity

        function setPrice(item){
            return parseFloat(item).toFixed(2)
        }
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/cart-new.js